<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <wcselect :option="{placeholder:'请选择认证类型',ischange:true,width:'200px',clearable:true,filterable:true}" 
                :value="param.status"
                :list="verifystatus"
                @finish="(val)=> {
                    param.status=val.value;
                    param.ischange=true;
                    GetList();
                }"
            />
        </el-form-item>
    </el-form>
</div>


<!-- 一级数据操作 -->
<div class="TTL-table top20" :ref="objloading" v-if="!param.isorder">
    <el-table :data="list" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column label="会员头像" align="center">
            <template #default="scope">
                <wcimage :option="{size:'middle'}" :value="scope.row.memberthumb" />
            </template>
        </el-table-column>
        <el-table-column prop="membername" label="会员名称" align="center" />
        <el-table-column prop="memberphone" label="手机" align="center"/>
        <el-table-column label="认证情况" align="center">
            <template #default="scope">
                <span>{{scope.row.verify_status}}</span>
            </template>
        </el-table-column>
        <el-table-column label="认证情况" align="center">
            <template #default="scope">
                <span class="TTL-username" @click="ShowMemberAuth(scope.row)">{{scope.row.auth_name}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="inputtime" label="提交时间" align="center"/>
    </el-table>
</div>


<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>

<!-- 认证信息 -->
<AuthShowLog :view="authshow.view" :status="verifystatus" :data="authshow.data" @finish="(val)=> {this.authshow.view=false;this.GetList();}" />

</template>

<script>
import INTERFACE_MODEL_MEMBER from '@/Interface/Es/member';
import AuthShowLog from '@/views/EsMembers/Module/AuthShowLog';
export default {

    components:{
        AuthShowLog
    },

    data() {
        return {
            objloading:'memberauthlog',
            param: {
                key:'',
                status:0,
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            memberauthtypes:[],
            list:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除数据'},
                {id:2,name:'批量修改数据'},
            ],
            verifystatus:[],
            authshow:{
                view:false,
                data:'',
            },

        }
    },

    mounted() {

        this.OnloadMethod(false);  //页数初始化
        this.GetStatusList(false); //获取认证状态

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
            this.GetMemberAuthTypes(isfresh);
            this.GetStatusList(isfresh);
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                this.GetList();
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetList();
            }


        },


        /** 显示认证信息 **/
        ShowMemberAuth(authinfo) {
            this.authshow.view=true;
            this.authshow.data=authinfo;
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_MEMBER.GET_AUTH_LOG(this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
            });
        },


        /** 获取会员认证类型 **/
        GetMemberAuthTypes(isfresh) {
            this.$method.GET_MEMBER_AUTH_TYPES(isfresh).then((res) => {this.memberauthtypes=res;console.log(res)});
        },

        /** 获取认证状态信息 **/
        GetStatusList(isfresh) {
            this.$method.GET_MEMBER_AUTH_LOG_STATUS(isfresh).then((res) => {this.verifystatus=res;console.log(res)});
        },


    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.TTL-username {color:#666eeb;cursor: pointer;}
.TTL-username span {display: inline-block;width:100%;}
.TTL-btn-box {display: inline-flex;align-content: flex-end;align-items: center;padding:15px 0;}
</style>